import PropTypes from 'prop-types' // eslint-disable-line no-unused-vars
import css from './search-drop-down.css'
import { isEmpty, groupBy } from 'lodash'
import TapLink from 'shared/components/tap-link'
import { googleAnalyticsEvent } from 'shared/util/analytics'
import React from 'react'

const gaEvent = { action: 'Search', category: 'Search Bar' }
const getItem = (label, focusedIndex, device) => ({ name, link, img }, index) => {
    const avatar = <div className={css.avatar} style={{ backgroundImage: `url(${img})` }} />
    return (
        <li className={label === 'Channel' ? css.channelDropdownListItem : css.nonChannelDropdownListItem} key={index}>
            {device === 'desktop' ? (
                <a
                    className={index === focusedIndex ? css.focusedIndexLink : null}
                    href={link}
                    onMouseDown={() => {
                        googleAnalyticsEvent({ label, ...gaEvent })
                        location.href = link
                    }}
                >
                    <span className={css.regularDropdownItemInfo}>
                        {img && avatar}
                        {name}
                    </span>
                </a>
            ) : (
                <TapLink
                    className={css.mobileRegularDropdownItem}
                    link={link}
                    onTap={() => googleAnalyticsEvent({ label, ...gaEvent })}
                >
                    <span className={css.regularDropdownItemInfo}>
                        {img && avatar}
                        {name}
                    </span>
                </TapLink>
            )}
        </li>
    )
}

const getChannelItem = (label, device, callback, focusedIndex) => ({ name, slug, img }, index) => {
    const avatar = <div className={css.avatar} style={{ backgroundImage: `url(${img})` }} />
    return (
        <li className={css.channelDropdownListItem} key={index}>
            {device === 'desktop' ? (
                <a
                    className={index === focusedIndex ? css.focusedIndexLink : css.tappableLink}
                    onMouseDown={() => callback(slug, img)}
                >
                    <span className={`${css.channelName}`}>
                        {img && avatar}
                        {name && <span className={css.channelListItemInfo}>{name}</span>}
                        {label === 'Channel' ? <span className={css.username}>@{slug}</span> : null}
                    </span>
                </a>
            ) : (
                <TapLink className={css.tappableLink} onTap={() => callback(slug, img)}>
                    <span className={`${css.mobileChannelName}`}>
                        {img && avatar}
                        <span className={css.mobileChannelInfo}>
                            {name} {name ? <br /> : null}
                            {label === 'Channel' ? <span className={css.mobileUsername}>@{slug}</span> : null}
                        </span>
                    </span>
                </TapLink>
            )}
        </li>
    )
}

const { arrayOf, string, shape, number, object, func } = PropTypes
export default class SearchDropDown extends React.Component {
    static propTypes = {
        items: arrayOf(
            shape({
                name: string.isRequired,
                link: string.isRequired,
                type: string.isRequired,
            }),
        ),
        style: object,
        device: string,
        searchType: string,
        onChannelSelected: func,
        focusedIndex: number,
    }

    render() {
        const { items = [], style, device, searchType, onChannelSelected, focusedIndex } = this.props
        const { tags, channels, trending } = groupBy(items, ({ type }) => type)
        if (searchType === 'channel') {
            return (
                <div className={css[`${device}SearchBarDropDown`]} style={device === 'desktop' ? null : style}>
                    {!isEmpty(channels) && (
                        <ul className={css.channel}>
                            {channels.map(getChannelItem('Channel', device, onChannelSelected, focusedIndex))}
                        </ul>
                    )}
                </div>
            )
        } else {
            return (
                <div className={css[`${device}SearchBarDropDown`]} style={device === 'desktop' ? null : style}>
                    {!isEmpty(trending) && <h5>Trending Searches</h5>}
                    {!isEmpty(trending) && <ul>{trending.map(getItem('Trending Term', focusedIndex, device))}</ul>}
                    {!isEmpty(tags) && <ul>{tags.map(getItem('Search Term', focusedIndex, device))}</ul>}
                    {!isEmpty(channels) && <h5 className={css.dividingHeader}>Channels</h5>}
                    {!isEmpty(channels) && (
                        <ul className={css.channel}>{channels.map(getItem('Channel', focusedIndex, device))}</ul>
                    )}
                </div>
            )
        }
    }
}
